import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import * as Entities from '@shared/entities';
import * as Models from '@shared/models';
import { ConfigService } from '../services/config.service';

@Injectable({
  providedIn: 'root',
})
export class RetailerHierarchyApi {
  private serviceUri: string = '';

  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) {
    this.config.Config.subscribe((config) => {
      if (config?.apiUri) {
        this.serviceUri = `${config.apiUri}/retailerHierarchy/`;
      }
    });
  }

  getRetailerHierarchies(request: Models.IRetailerRequestModel): Observable<Entities.RetailerOrgLookup[]> {
    return this.http
      .post<
        Entities.RetailerOrgLookup[]
      >(this.serviceUri + 'getRetailerHierarchies', JSON.stringify(request), { headers: { 'Content-Type': 'application/json' } })
      .pipe(
        map((response: Entities.RetailerOrgLookup[]) => {
          return response;
        }),
        catchError(this.handleError<Entities.RetailerOrgLookup[]>('GetRetailerHierarchies', []))
      );
  }

  private handleError<T>(_operation = 'operation', result?: T): (error: unknown) => Observable<T> {
    return (error: unknown): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
}
